module.exports = __webpack_public_path__ + "bg_txz.png?3f6cd4b0b73c8732c7c58b4a73f72d51";